import { CommandType } from './command-type.interface';

export const BLINDS: CommandType = {
  name: 'Blinds',
  description: 'Open or Close Blinds or Shades',
  route: 'blinds',
  category: 'Security & Access',
  order: 1,
  whitelist: [
    {
      proxy: 'blind',
      commands: [
        { id: 0, command: 'SET_LEVEL_TARGET:LEVEL_TARGET_OPEN', icon: 'blinds-open' },
        { id: 0, command: 'SET_LEVEL_TARGET:LEVEL_TARGET_CLOSED', icon: 'blinds' },
        { id: 0, command: 'TOGGLE', icon: 'blinds' },
      ]
    },
    {
      proxy: 'blindV2',
      commands: [
        { id: 0, command: 'LOUVERS_OPEN', icon: 'blinds-open' },
        { id: 0, command: 'LOUVERS_CLOSE', icon: 'blinds' },
        { id: 0, command: 'LOUVERS_TOGGLE', icon: 'blinds' },
        { id: 0, command: 'BLINDS_OPEN', icon: 'blinds-open' },
        { id: 0, command: 'BLINDS_CLOSE', icon: 'blinds' },
        { id: 0, command: 'BLINDS_TOGGLE', icon: 'blinds' },
        { id: 0, command: 'BLINDS_GOTO_LEVEL', icon: 'blinds' },
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-simple/command-types/blinds.type.ts